import _ from 'underscore';
import { getCollapsiblePanelStyles } from '../../shared';
import { isSearchShoppingCampaign } from '../step-utils';

export const getAdGroupStyles = (components, theme) => ({
  collapsiblePanel: getCollapsiblePanelStyles(components, theme),
  toggle: {
    marginBottom: '0px',
    alignSelf: 'center',
  },
  adgroupShell: {
    '& .base-options-stack': {
      // width: '100%',
    },
    '& .collapse-container': {
      width: 'inherit',
    },
    '& .contextual-target': {
      maxWidth: '1000px',
    },
    '& .ms-ChoiceFieldGroup label': {
      padding: 0,
      fontWeight: 400,
    },
  },
  urlOptionsContainer: {
    maxWidth: 435,
  },
});

export const getTargetingPanels = (flow) => {
  if (!isSearchShoppingCampaign(flow)) {
    return {
      basicOptions: [
        'location-target',
        'gender-target',
        'age-target',
        // 'predictive-targeting',
      ],
      advancedOptions: [
        'audience-target',
        'company-target',
        'industry-target',
        'job-target',
        // // PT cannot be disabled until algorithm team fix an issue
        // 'predictive-targeting-control',
      ],
      moreOptions: [
        'start-end-dates',
        'ad-schedule',
      ],
    };
  }

  return {
    basicOptions: [
      'location-target',
      // 'gender-target',
      // 'age-target',
    ],
    advancedOptions: [
      'device-target',
      // 'audience-target',
      // 'company-target',
      // 'industry-target',
      // 'job-target',
    ],
    moreOptions: [
      'start-end-dates',
      'ad-schedule',
      'ad-distribution',
    ],
  };
};

export const getAdGroupSettingsPanels = (flow, showBid) => {
  if (!isSearchShoppingCampaign(flow)) {
    return {
      basicOptions: _.compact([
        'ad-group-name',
        showBid ? 'bid-value' : null,
        'url-options',
        'start-end-dates',
        'ad-rotation',
      ]),
    };
  }

  return {
    basicOptions: _.compact([
      'ad-group-name',
      showBid ? 'bid-value' : null,
      'url-options',
      'start-end-dates',
      'ad-distribution',
      'ad-rotation',
    ]),
  };
};
